import { render, staticRenderFns } from "./verify_page.vue?vue&type=template&id=027466ec"
import script from "./verify_page.vue?vue&type=script&lang=js"
export * from "./verify_page.vue?vue&type=script&lang=js"
import style0 from "./verify_page.vue?vue&type=style&index=0&id=027466ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports